var exports = {
  "S": "CheckIcon__vo_uvt",
};

module.exports = exports;
